export const videoFields = [
    {
      fieldName: "videoId",
      fieldTitle: "Video Id",
      validationObj: {
        required: "Please Enter Video Id",
      },
  
      fieldType: "text",
    },
    {
      fieldName: "videoTitle",
      fieldTitle: "Video Title",
      validationObj: {
        required: "Please Enter Video Title",
      },
      fieldType: "text",
    },
    
  
    {
      fieldName: "videoLink",
      fieldTitle: "Video Link",
      validationObj: {
        required: "Please Enter Video Link",
        pattern: {
            value: /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w-]{11}$/,
            message: "Please enter a valid YouTube video link",
          },
      },
      fieldType: "text",
    },
    {
      fieldName: "videoType",
      fieldTitle: "Video Type",
      validationObj: {
        required: "Please Select Video Type",
      },
      fieldType: "select",
      options: [
        { label: 'Speech', value: 'speech' },
        { label: 'Video', value: 'video' },
      ]
    },
    
    {
      fieldName: "imageUpload",
      fieldTitle: "Thumbnail Image",
      fieldType: "upload",
    },
  ];
  
  export const videoTableHeader = [
    {
      id: 'sno',
      numeric: false,
      label: 'S.No',
      disabled: true,
    },
    {
      id: "videoId",
      numeric: false,
      label: "Video Id",
      disabled: true,
    },
    {
      id: "videoTitle",
      numeric: false,
      label: "Video Title",
      disabled: true,
    },
   
    {
      id: "videoLink",
      numeric: false,
      label: "Video Link",
      disabled: true,
    },
    {
      id: "videoType",
      numeric: false,
      label: "Video type",
      disabled: true,
    },
    {
        id: "image",
        numeric: false,
        label: "Thumbnail Image",
        disabled: true,
      },
    {
      id: "action",
      numeric: false,
      label: "Actions",
      disabled: true,
    },
  ];
  